export const yearlyColumns = [
  {
    label: '结算项目数量',
    value: 'month',
    headName: 'headId0'
  },
  {
    label: '结算调查员人数',
    value: 'aaa',
    headName: 'headId1'
  },
  {
    label: '到手金额（元）',
    value: 'sss',
    headName: 'headId2'
  },
  {
    label: '服务费（元）',
    value: 'ddd',
    headName: 'headId3'
  },
  {
    label: '结算总费用（元）',
    value: 'fff',
    headName: 'headId4'
  }
]
export const projectCol = [
  {
    value: 'projectName',
    label: '结算项目名称'
  },
  {
    value: 'departName',
    label: '所属部门'
  },
  {
    value: 'investigatorsNum',
    label: '结算调查员人数'
  },
  {
    value: 'expectedYuanAmount',
    label: '到手金额(元)',
    sortable: true
  },
  {
    value: 'serviceYuanAmount',
    label: '服务费(元)',
    sortable: true
  },
  {
    value: 'operationalYuanAmount', //这里取得结算总费用
    label: '结算总费用(元)',
    width: '150px',
    sortable: true
  },
  {
    value: 'action',
    label: '操作',
    width: '80px',
    fixed: 'right'
  }
]
export const departCol = [
  {
    value: 'settleDept',
    label: '所属部门'
  },
  {
    value: '',
    label: '结算项目数',
    sortable: true
  },
  {
    value: 'investigatorsNum',
    label: '结算调查员人数',
    sortable: true
  },
  {
    value: 'expectedYuanAmount',
    label: '到手金额（元）',
    sortable: true
  },
  {
    value: 'serviceYuanAmount',
    label: '服务费（元）',
    sortable: true
  },
  {
    value: 'operationalYuanAmount',
    label: '结算总费用（元）',
    sortable: true
  },
  {
    value: 'action',
    label: '操作',
    width: '80px',
    fixed: 'right'
  }
]
export const investigatorCol = [
  {
    value: 'investigatorName',
    label: '调查员'
  },
  {
    value: '',
    label: '关联项目数',
    sortable: true
  },
  {
    value: 'expectedYuanAmount',
    label: '到手金额（元）',
    sortable: true
  },
  {
    value: 'serviceYuanAmount',
    label: '服务费（元）',
    sortable: true
  },
  {
    value: 'operationalYuanAmount',
    label: '结算总费用（元）',
    sortable: true
  },
  {
    value: 'action',
    label: '操作',
    width: '80px',
    fixed: 'right'
  }
]
export const creatorCol = [
  {
    value: '',
    label: '发起人'
  },
  {
    value: '',
    label: '结算项目数',
    sortable: true
  },
  {
    value: 'investigatorsNum',
    label: '结算调查员人数'
  },
  {
    value: 'expectedYuanAmount',
    label: '到手金额(元)',
    sortable: true
  },
  {
    value: 'serviceYuanAmount',
    label: '服务费(元)',
    sortable: true
  },
  {
    value: 'operationalYuanAmount', //这里取得结算总费用
    label: '结算总费用(元)',
    sortable: true
  },
  {
    value: 'action',
    label: '操作',
    width: '80px',
    fixed: 'right'
  }
]
export const typeCol = [
  {
    value: '',
    label: '结算类型'
  },
  {
    value: 'investigatorsNum',
    label: '结算调查员人数'
  },
  {
    value: 'expectedYuanAmount',
    label: '到手金额(元)',
    sortable: true
  },
  {
    value: 'serviceYuanAmount',
    label: '服务费(元)',
    sortable: true
  },
  {
    value: 'operationalYuanAmount', //这里取得结算总费用
    label: '结算总费用(元)',
    width: '200px',
    sortable: true
  },
  {
    value: 'action',
    label: '操作',
    width: '80px',
    fixed: 'right'
  }
]
export const searchFields = [
  {
    label: '结算名称',
    value: 'jobExecutionName',
    type: 'input',
    originvalue: '',
    value: '',
    span: 8
  },
  {
    start: '开始时间',
    end: '结束时间',
    value: 'auditTime',
    type: 'date-picker',
    dateType: 'daterange',
    format: 'yyyy-MM-dd',
    originvalue: '',
    value: [],
    hasMaxMinValue: true,
    span: 12
  }
]

export const tabKey = {
  ALL: 0,
  WAIT_APPROVE: 1,
  WAIT_PAY: 2,
  ALREADY_PAY: 3
}

export const tabList = [
  { key: tabKey.ALL, skey: 'all', label: '全部' },
  { key: tabKey.WAIT_APPROVE, skey: 'ready', label: '待审批' },
  { key: tabKey.WAIT_PAY, skey: 'paying', label: '待支付' },
  { key: tabKey.ALREADY_PAY, skey: 'paid', label: '已支付' }
]
